import { render, staticRenderFns } from "./MaterialRead.vue?vue&type=template&id=1cad83ee&scoped=true&"
import script from "./MaterialRead.vue?vue&type=script&lang=js&"
export * from "./MaterialRead.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRead.vue?vue&type=style&index=0&id=1cad83ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cad83ee",
  null
  
)

export default component.exports